





















































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import MainButton from '@/shared/buttons/main-button.component.vue';
import ActionButton from '@/shared/buttons/action-button.component.vue';
import PushOrderUtils from '@/shared/utils/push-order-utils';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store'
import Datasource from '@/domain/business-unit/entity/datasource.entity';
import BusinessUnitService from '@/domain/business-unit/service/business-unit.service';
import JustifyModal from '@/shared/modal/justify-modal.component.vue';
import EventBus, { Event } from '@/event.bus'
import { JustifyType } from '@/domain/justify/domain/justify-type.enum';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';
import UserAuthority from '@/domain/security/user-authority.service';
import RequestExpirationContract from '@/domain/contract/entity/request-expiration-contract.entity';
import ContractLink from '@/domain/contract/entity/contract-link.entity';
import Pagination from '@/domain/pagination.entity';
import ContractService from '@/domain/contract/service/contract.service';
import ContractGroupService from '@/domain/contract/service/contract-group.service';
import BindInstance from '@/domain/contract/entity/bind-instance.entity';
import Contract from '@/domain/contract/entity/contract.entity';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import ContractPersist from '@/domain/contract/entity/contract-persist.entity';
import JustifyPersist from '@/domain/justify/domain/justify-persist.entity';
import ContractContent from './contract-info-content.component.vue';
import TabComponent from './tab.component.vue';
import ItemsComponent from './itens/items.component.vue';
import InstancesComponent from './instances/instances.component.vue';
import LinksComponent from './links/links.component.vue';
import ContractInfoModalNewInstance from './contract-into-modal-new-instance.component.vue';
import ContractInfoModalNewLink from './contract-into-modal-new-link.component.vue';
import ReadjustmentComponent from './readjustment/readjustment.component.vue';
import DiscountComponent from './discount/discount.component.vue';
import FeeComponent from './fee/fee.component.vue';
import ContractHistoryComponent from './history/history.component.vue';
import ContractHistoryModal from '../contract-history/contract-history-modal.component.vue';
import RequestCancelContractModal from './request-cancel-contract.component.vue';
import JustificationReviewedModal from './justification-reviewed-modal.component.vue';
import AdditionalInfoComponent from './additional-info/additional-info.component.vue';
import CancellationDataComponent from './cancellation-data/cancellation-data.component.vue';
import ContractInfoTabControl from './contract-info-tab-index';

@Component({
  components: {
    MainButton,
    ActionButton,
    VbTooltipSlot,
    ContractContent,
    TabComponent,
    ItemsComponent,
    InstancesComponent,
    LinksComponent,
    ContractInfoModalNewInstance,
    ContractInfoModalNewLink,
    JustifyModal,
    ModalWarning,
    ModalComponent,
    ReadjustmentComponent,
    DiscountComponent,
    FeeComponent,
    ContractHistoryComponent,
    ContractHistoryModal,
    RequestCancelContractModal,
    AdditionalInfoComponent,
    JustificationReviewedModal,
    CancellationDataComponent,
  },
})
export default class ContractInfo extends Vue {
  contract: Contract = Contract.of({});

  businessUnitId;

  persistBindInstance: BindInstance = BindInstance.of({});

  newInstanceModal: boolean = false;

  persistLink: ContractLink = ContractLink.of({});

  newLinkModal: boolean = false;

  showJustityModal: boolean = false;

  showJustificationModal: boolean = false;

  showJustifyWarning: boolean = false;

  warningMessage: string = 'Deseja realmente prosseguir? Ao clicar no botão Sim, as alterações serão imediatamente realizadas. ';

  justifyType: JustifyType = JustifyType.CONTRACT_BILLING_DISABLE;

  editModeValue: boolean = false;

  showHistoryModal: boolean = false;

  datasources: Datasource[] = [];

  tab: number = 0;

  tabControl: ContractInfoTabControl = ContractInfoTabControl.ITENS;

  userAuthority: UserAuthority = new UserAuthority();

  showRequestCancelContractModal: boolean = false;

  showPreviewConfirmDialog: boolean = false;

  loadingSwitchPreview: boolean = false;

  cancelContractRequest: RequestExpirationContract = new RequestExpirationContract();

  links: ContractLink[] = [];

  enableRevisionFlow: boolean = false;

  enableRevision: boolean = false;

  billingDaily: boolean = false;

  isContractGroup: boolean = false;

  loadingExpireContract: boolean = false;

  linksPagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 5,
  });

  get showTabControlLinks(): boolean {
    return this.tabControl === ContractInfoTabControl.LINKS;
  }

  setHasContractGroup() {
    this.isContractGroup = !!(this.contract.contractGroup && this.contract.contractGroup.id);
  }

  hasContractGroup() {
    return (this.contract.contractGroup.id && this.userAuthority.isAdminOrSupervisor());
  }

  showSeparatorAfterTradingName(): boolean {
    return !!(this.contract.customer.tradingName && this.contract.customer.name);
  }

  get modalOptions(): object {
    return {
      color: 'warning',
      text: 'Cancelar',
    }
  }

  get modalReOpenOptions(): object {
    return {
      color: 'warning',
      text: 'Reabrir',
    }
  }

  isPushOrder() {
    return this.contract.pushOrderNumber != null
      && this.contract.pushOrderExpirationDate != null;
  }

  get buttonPushOrderColor() {
    if (!this.isPushOrder()) return PushOrderUtils.COLOR_WARNING;
    return PushOrderUtils.getColor(this.contract.pushOrderExpirationDate);
  }

  get pushOrderIcon() {
    return PushOrderUtils.getIcon();
  }

  get getPushOrderTooltipContent() {
    if (!this.isPushOrder()) return 'Necessita de PO';
    return PushOrderUtils.getLegend(this.contract.pushOrderExpirationDate);
  }

  updateJustifyModalVisibility(value: boolean) {
    this.showJustityModal = value;
    if (!value) {
      this.justifyType = JustifyType.CONTRACT_BILLING_DISABLE;
    }
  }

  updateModalValue(value: boolean): void {
    this.newInstanceModal = value;
  }

  updateLinkModalValue(value: boolean): void {
    this.newLinkModal = value;
  }

  get items() {
    if (Object.values(this.contract).length !== 0) {
      return this.contract.currentVersion
        ? this.contract.currentVersion.items
        : [];
    }
    return [];
  }

  created() {
    const currentBU = UserBusinessUnitService.currentBusinessUnit;
    this.businessUnitId = currentBU.id;
    this.enableRevisionFlow = currentBU.enableRevisionFlow;
    this.enableRevision = currentBU.enableContractRevision;
    this.userAuthority.load(currentBU.profile);
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && this.$route.name.includes('Contrato')) {
        this.businessUnitId = businessUnit.id;
        this.enableRevisionFlow = businessUnit.enableRevisionFlow;
        this.enableRevision = businessUnit.enableContractRevision;
        this.billingDaily = businessUnit.billingDaily;
        this.userAuthority.load(businessUnit.profile);
        this.getContract();
        this.getDatasources();
      }
    })
    this.getContract();
    this.getDatasources();
    this.getLinks();
  }

  getDatasources() {
    if (this.businessUnitId) {
      BusinessUnitService.getDatasources(this.businessUnitId)
        .then((resp: any) => this.datasources = resp)
    }
  }

  go(path: string): void {
    this.$router.push(path);
  }

  getContract(): void {
    if (this.$route.params.id && this.businessUnitId) {
      ContractService.getContract(this.businessUnitId, this.$route.params.id)
        .then((response: any) => {
          this.contract = Contract.of(response);
        })
        .catch((err: any) => {
          this.go('/')
        })
        .finally(() => {
          this.setHasContractGroup();
        });
    }
  }

  updateContract(contractPersist: ContractPersist): void {
    ContractService.updateContract(this.businessUnitId, this.contract.id, contractPersist)
      .then(() => this.getContract())
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.editModeValue = false;
      });
  }

  back() {
    this.$router.back();
  }

  handleBillingSwitch() {
    if (this.contract.billing.enabled) {
      this.justifyType = JustifyType.CONTRACT_BILLING_DISABLE;
      this.showJustityModal = true;
      return;
    }
    this.showJustifyWarning = true;
  }

  handleRequestExpirationContractSwitch() {
    this.setHasContractGroup();
    this.showRequestCancelContractModal = true;
  }

  handleCancelExpirationRequestSwitch() {
    this.justifyType = JustifyType.CONTRACT_EXPIRATION_REVERSAL;
    this.showJustityModal = true;
  }

  get isJustifyTypeExpirationReversal(): boolean {
    return this.justifyType === JustifyType.CONTRACT_EXPIRATION_REVERSAL;
  }

  handlePreviewSwitch(value : boolean) {
    if (value && this.contract.contractModel === 'ASSISTED_PURCHASE') {
      this.showPreviewConfirmDialog = true;
      return;
    }
    this.switchPreview(value);
  }

  switchPreview(value: boolean) {
    this.loadingSwitchPreview = true;
    ContractService.switchPreview(this.businessUnitId, this.contract.id, value)
      .then(() => {
        if (this.contract.contractModel === 'ASSISTED_PURCHASE') {
          this.getContract();
        }
      })
      .catch((err: any) => {
        this.contract.isPreview = !value;
        VbSnackbarService.handleHttpError(err);
      })
      .finally(() => {
        this.loadingSwitchPreview = false;
        this.showPreviewConfirmDialog = false;
      });
  }

  confirmSwitchToPreview() {
    this.switchPreview(true);
  }

  cancelSwitchToPreview() {
    if (this.loadingSwitchPreview) return;
    this.contract.isPreview = false;
    this.showPreviewConfirmDialog = false;
  }

  handleCustomBillingSwitch(value : boolean) {
    ContractService.switchCustomBilling(this.businessUnitId, this.contract.id, value)
      .catch((err: any) => {
        this.contract.isCustomBilling = !value;
        VbSnackbarService.handleHttpError(err);
      })
  }

  handleBillingDaily(value : boolean) {
    ContractService.switchBillingDaily(this.businessUnitId, this.contract.id, value)
      .catch((err: any) => {
        this.contract.isBillingDaily = !value;
        VbSnackbarService.handleHttpError(err);
      })
  }

  handleBillingWithPushOrderSwitch(value: boolean) {
    ContractService.switchBillingWithPushOrder(this.businessUnitId, this.contract.id, value)
      .catch((err: any) => {
        this.contract.isBillingPushOrder = !value;
        VbSnackbarService.handleHttpError(err);
      })
  }

  handleCancelModal() {
    this.showJustificationModal = false
  }

  handleReviewedSwitch() {
    if (this.contract.reviewed) {
      this.showJustificationModal = true;
      return;
    }
    this.switchReviewed(!this.contract.reviewed);
  }

  switchReviewed(value: boolean, justification?: string) {
    this.showJustificationModal = false;
    this.contract.reviewed = value;
    ContractService.switchReviewed(this.businessUnitId, this.contract.id, value, justification)
      .catch((err: any) => {
        VbSnackbarService.handleHttpError(err);
      })
  }

  persistJustify(values) {
    const justify: JustifyPersist = values.justify;
    const file: any = values.file;

    if (this.isJustifyTypeExpirationReversal) {
      this.persistCancelExpirationRequest(justify);
      return;
    }

    ContractService.disableBilling(this.businessUnitId, this.contract.id, justify, file)
      .then(() => {
        this.contract.disableBilling(justify);
        this.showJustityModal = false;
        VbSnackbarService.showSuccess('Faturamento desativado com sucesso')
        this.contract.setHasInactivation(true);
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
  }

  persistCancelExpirationRequest(justify: JustifyPersist) {
    const request = justify.revertAllFromContractGroup
      ? ContractGroupService.cancelExpirationRequestForGroup(
        this.contract.contractGroup.id, justify.justificationId, justify.observation,
      )
      : ContractService.cancelExpirationRequest(
        this.contract.id, justify.justificationId, justify.observation,
      );

    request
      .then(() => {
        this.updateJustifyModalVisibility(false);
        VbSnackbarService.showSuccess('Solicitação de Encerramento revertida com sucesso!');
        this.getContract();
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
  }

  enableBilling(justify: JustifyPersist) {
    ContractService.enableBilling(this.businessUnitId, this.contract.id)
      .then(() => {
        this.contract.billing.enabled = true;
        VbSnackbarService.showSuccess('Faturamento ativado com sucesso')
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.showJustifyWarning = false;
      });
  }

  get profile() {
    return this.userAuthority.profile;
  }

  get isAdministrator(): boolean {
    return this.userAuthority.isAdministrator();
  }

  get isAuditor(): boolean {
    return this.userAuthority.isAuditor();
  }

  get isSupervisor(): boolean {
    return this.userAuthority.isSupervisor();
  }

  get isAdminOrSupervisor(): boolean {
    return this.userAuthority.isAdminOrSupervisor();
  }

  get hasPermission(): boolean {
    return this.userAuthority.canManageCalculation();
  }

  get previewConfirmModalOptions(): ModalOptions {
    return {
      title: 'Confirmar entrada em prévia',
      description: 'Atenção, ao mover um contrato de compra assistida para prévia, todas as regras de cálculo vinculadas serão apagadas. Quando o contrato sair de prévia, essas regras de cálculo serão integradas novamente.',
      showOk: true,
      labelOk: 'Confirmar',
      loadingOk: this.loadingSwitchPreview,
      disabledOk: this.loadingSwitchPreview,
      showCancel: !this.loadingSwitchPreview,
      labelCancel: 'Cancelar',
      persistent: true,
    };
  }

  closeRequestCancelContractModal(value: boolean) {
    this.showRequestCancelContractModal = value;
  }

  requestExpireContract(data: RequestExpirationContract) {
    this.loadingExpireContract = true;
    ContractService.expireContract(this.contract.id, data).then(() => {
      this.showRequestCancelContractModal = false;
      VbSnackbarService.showSuccess('Solicitação de Cancelamento cadastrada com sucesso!');
    })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => {
        this.loadingExpireContract = false;
        this.getContract()
      });
  }

  getLinks() {
    ContractService.getLinks(this.linksPagination, this.$route.params.id)
      .then((response) => {
        this.links = ContractLink.ofList(response.content);
        this.linksPagination.total = response.totalElements;
        this.linksPagination.pageCount = response.totalPages;
      })
  }

  updatePagination(pagination: Pagination) {
    this.linksPagination = pagination;
    this.linksPagination.verifyPage();
    this.getLinks();
  }
}
